import { render, staticRenderFns } from "./EditPartner.vue?vue&type=template&id=f23df114&scoped=true"
import script from "./EditPartner.vue?vue&type=script&lang=js"
export * from "./EditPartner.vue?vue&type=script&lang=js"
import style0 from "./EditPartner.vue?vue&type=style&index=0&id=f23df114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23df114",
  null
  
)

export default component.exports